// @ts-strict-ignore
import { Card, List, mediaQuery } from "@hubble/web";
import styled from "styled-components";

export const CoinMetricsCardContainer = styled.div`
  grid-area: 1 / 1 / 3 /3;
  @media ${mediaQuery.mobileXsDown} {
    grid-area: 1 / 1 / 3 / -1;
  }
`;

export const CoinMetricsCardStyled = styled(Card)`
  min-height: calc(100% - 40px);
` as typeof Card;

export const CoinMetricsList = styled(List)`
  padding-left: 0;
  margin: 0;
`;
